export default __webpack_public_path__ + "static/media/sports10.0aaf3319.png";